import {
  emptyString,
  HTTP_HEADER_NAMES,
  AUTHORIZATION_SCHEME,
} from "../constants";
import { getToken } from "../system";
export function authHeader() {
  // return authorization header with jwt token
  const payload = getToken();

  const userToken = payload || emptyString;
  if (userToken && userToken.length > 0) {
    return {
      [HTTP_HEADER_NAMES.AUTHORIZATION]: `${AUTHORIZATION_SCHEME} ${userToken}`,
    };
  }
  return {};
}
